import { COLOR, FONT_SIZE } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";
import { LINE_STYLE } from "~/styles/line-style";

export const LIList = styled.li<{ isHistory?: boolean }>`
  width: 100%;
  font-size: 14px;
  height: 40px;

  ${({ isHistory }) =>
    isHistory &&
    `
    display: flex;
    align-items: center;
    justify-content: space-between;
  `}
`;

export const ButtonItem = styled.button<{ isHistory?: boolean }>`
  padding: 8px 0px;
  width: ${({ isHistory }) => (isHistory ? "calc(100% - 32px)" : "100%")};
  font-size: ${FONT_SIZE.S}px;
  display: flex;
`;

export const SpanText = styled.span`
  color: ${COLOR.GRAY900.code};
  ${LINE_STYLE(1)}
`;

export const SpanGravureText = styled.span`
  color: ${COLOR.GRAY500.code};
  flex-shrink: 0;
`;

export const RemoveButton = styled.button`
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
